import {Controller} from "stimulus";

export default class extends Controller {
  static targets = ['close']

  connect() {
  }

  handleClose() {
    this.closeTarget.parentElement.classList.toggle('is-active');
  }
}
